import { CoverageManualSession } from '@features/eligibility-checks/components/CoverageManualSession';
import { Alert, Button, Skeleton } from '@mui/material';
import type { AdminEligibilityItemResponse } from '@store/generated/admin';

import {
  useGetAdminEligibilityRecordQuery,
  useSaveAdminEligibilityRecordMutation,
} from '../store/hooks';

interface EligibilityOverrideFormProps {
  item: AdminEligibilityItemResponse;
  onCollapse: () => void;
}

export function EligibilityOverrideForm({ item, onCollapse }: EligibilityOverrideFormProps) {
  const eligibilityId = item.eligibility_snapshot_id ?? '';
  const query = useGetAdminEligibilityRecordQuery({ eligibilityId }, { skip: !eligibilityId });
  const [save, { isLoading }] = useSaveAdminEligibilityRecordMutation();
  if (!eligibilityId) return <Alert severity="error">This result has no eligibility source.</Alert>;
  if (query.error && !query.currentData)
    return (
      <Alert severity="error">
        Could not load current benefits. <Button onClick={() => void query.refetch()}>Retry</Button>
      </Alert>
    );
  if (!query.currentData) return <Skeleton aria-label="Loading current benefits" height={160} />;
  return (
    <CoverageManualSession
      current={query.currentData}
      label={item.payer_name ?? 'Insurance coverage'}
      allowed={!query.error}
      recoveryMessage={query.error ? "Could not refresh current benefits. Your entries are preserved." : null}
      onRetryDetails={() => void query.refetch()}
      isSaving={isLoading}
      saveManual={eligibilityManualRequest =>
        save({ eligibilityId, eligibilityManualRequest }).unwrap()
      }
      onClose={onCollapse}
      onSaved={onCollapse}
    />
  );
}
